import { Reveal } from "./Reveal";
import { UserPlus, Upload, ShoppingBag, Wallet } from "lucide-react";

const steps = [
  { icon: UserPlus, title: "Inscrivez-vous", text: "Créez votre compte partenaire en quelques minutes et signez le contrat en ligne." },
  { icon: Upload, title: "Publiez vos photos", text: "Importez vos clichés de resort. Nous les présentons aux vacanciers concernés." },
  { icon: ShoppingBag, title: "Vos photos se vendent", text: "Les clients achètent vos souvenirs via notre plateforme sécurisée par Stripe." },
  { icon: Wallet, title: "Vous êtes payé", text: "80 % du prix vous est reversé sous 24 h. Suivez tout depuis votre tableau de bord." },
];

export default function HowItWorks() {
  return (
    <section id="comment" className="py-24 md:py-32 scroll-mt-20" data-testid="how-it-works-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <div className="text-xs font-black uppercase tracking-label text-[#F97316] mb-4">Le manifeste</div>
          <h2 className="text-3xl md:text-5xl font-black tracking-tighter text-[#0A0A0A] max-w-2xl leading-tight">
            Quatre étapes. Zéro friction.
          </h2>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-y-14 gap-x-6">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={i} delay={i * 0.1}>
                <div className="relative" data-testid={`step-${i + 1}`}>
                  <span className="absolute -top-10 -left-2 text-8xl font-black text-stroke select-none pointer-events-none">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="relative">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#0A0A0A] text-[#F97316] mb-5">
                      <Icon className="w-6 h-6" />
                    </div>
                    <h3 className="text-xl font-bold tracking-tight text-[#0A0A0A]">{s.title}</h3>
                    <p className="mt-2 text-sm text-[#52525B] font-light leading-relaxed">{s.text}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
